import axios from "axios";
import env from "variables/config";
import { errorHandler } from "./utils";

axios.defaults.baseURL = env.apiUrl;

const config = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};

export interface NotificationItem {
    type: string;
    priority: number;
    prospect: any;
    reason: string;
    daysOverdue?: number;
    daysUntil?: number;
    daysSinceContact?: number;
    daysSinceActivity?: number;
    lastResponseDate?: string;
}

export interface NotificationSummary {
    totalNotifications: number;
    overdue: number;
    dueToday: number;
    dueTomorrow: number;
    dueThisWeek: number;
    recentResponses: number;
    notContactedRecently: number;
    hotProspects: number;
    stale: number;
    noNextAction: number;
}

export interface NotificationHubResponse {
    notifications: NotificationItem[];
    summary: NotificationSummary;
}

export const getNotificationHub = async (): Promise<NotificationHubResponse | null> => {
    try {
        const res = await axios.get("/notifications/hub", config());
        return res?.data || null;
    } catch (err) {
        errorHandler(err);
        return null;
    }
};

export const snoozeNotification = async (prospectId: string, days: number = 1) => {
    try {
        const res = await axios.post(
            `/notifications/snooze/${prospectId}`,
            { days },
            config()
        );
        return res?.data;
    } catch (err) {
        errorHandler(err);
        return null;
    }
};

export const markAsContacted = async (
    prospectId: string,
    type: string = "send-email",
    subject?: string
) => {
    try {
        const res = await axios.post(
            `/notifications/mark-contacted/${prospectId}`,
            { type, subject },
            config()
        );
        return res?.data;
    } catch (err) {
        errorHandler(err);
        return null;
    }
};
